// extracted by mini-css-extract-plugin
export default {"fullScreen":"styles_fullScreen__lBYfa","close":"styles_close__uwMMz"};